module.exports = __webpack_public_path__ + "img/point_booster.dfe1d5e2.png";